import classNames from 'classnames/bind';
import styles from './TipCards.module.scss';
import TipItem from './TipItem';

const cx = classNames.bind(styles);

function TipList({className, data, loadTips, hidescroll = false }) {
  return (
    <div className={cx('articles-wrapper', className,{ ['hide-scroll']: hidescroll })}>
      {data.map((tip, index) => (
        <TipItem key={index} tip={tip} type={tip.type_name} loadTips={loadTips} />
      ))}
    </div>
  );
}

export default TipList;
